import React from 'react';
import BasicCard from "../../components/basics/cards/BasicCard";
import Button from 'react-bootstrap/Button' 
import { CommonAPIService } from "../../services/apis/CommonAPIService";

import './basicReport.css'

function BasicReportDownload({ pageConfig, filterArray, excelFileName, downloadConfig, downloadItems }) {
 
    if (downloadConfig) {
        excelFileName = downloadConfig.excelFileName
    } else if (excelFileName) {

    } else {
        excelFileName = pageConfig.controllerName
    }


    const handleDownloadClick = () => {
        const filterArrayString = encodeURIComponent(JSON.stringify(filterArray));
 
        const { apiName, controllerName, pageSettings } = pageConfig
        
        CommonAPIService.callApiUsingUrlReturnBlob(`${apiName}${controllerName}/Download?filterArray=${filterArrayString}`)
            .then(blob => {
                // Create a URL for the blob
                const url = URL.createObjectURL(blob);

                // Create a link element and set its href attribute to the blob URL
                const link = document.createElement('a');
                link.href = url;

                // Set the link element's download attribute to the desired file name
                link.download = excelFileName;

                // Click the link to download the file
                link.click();

                // Clean up the URL and link elements
                URL.revokeObjectURL(url);
                link.remove();
            }, [apiName], [controllerName], [filterArray])
            .catch(error => console.error(error));
    };

    return (
        <BasicCard cardConfig={{ cardTitle: 'Download', cardHeadingElement: 'h5'}}>
            <span className='brd-download-items'>
                <Button variant='primary' onClick={handleDownloadClick}>
                    Download
                </Button>
            </span>
        </BasicCard>
    );
}



export default BasicReportDownload